import Form from '@sendsprint/ui-react/dist/components/Form/formContainer';
import ClientApi from '@src/types/client';
import React from 'react';
import usePaymentLinkForm from '../../hooks/usePaymentLinkForm';
import SinglePaymentLinkFormInner from './singlePaymentLinkFormInner';
import Dialog2, { Dialog2Header } from '@src/components/dialog2';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  paymentLinkObj?: ClientApi.General.PaymentLinkI | undefined;
  shouldRedirect?: boolean;
  variant?: 'receiver' | 'raas';
  shouldShowDialog?: boolean;
}

export interface PaymentLinkFormI {
  linkName: string;
  amount: string;
  description: string;
  targetCurrency: string;
  redirectUrl: string;
}

const SinglePaymentLinkForm = ({
  handleClose,
  isOpen,
  paymentLinkObj,
  shouldRedirect = true,
  variant = 'receiver',
  shouldShowDialog
}: Props) => {
  const paymentLinkResponse = usePaymentLinkForm({
    handleClose,
    paymentLinkObj,
    shouldRedirect,
    variant
  });

  const { handleSubmit, initialValues, title, validationSchema } = paymentLinkResponse;

  return (
    <>
      {!shouldShowDialog && (
        <Form<PaymentLinkFormI>
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          <SinglePaymentLinkFormInner variant={variant} paymentLinkResponse={paymentLinkResponse} />
        </Form>
      )}
      {shouldShowDialog && (
        <Dialog2 handleClose={handleClose} isOpen={isOpen} disableOverlayClick>
          <Dialog2Header handleClose={handleClose} label={title} />
          <Form<PaymentLinkFormI>
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmit}>
            <SinglePaymentLinkFormInner
              variant={variant}
              paymentLinkResponse={paymentLinkResponse}
            />
          </Form>
        </Dialog2>
      )}
    </>
  );
};

export default SinglePaymentLinkForm;
